export const INSERT_SOCKET_MESSAGE = 'INSERT_SOCKET_MESSAGE';
export const SURFER_STATE_CHANGED = 'SURFER_STATE_CHANGED';
export const SURFER_ADDRESS_CHANGED = 'SURFER_ADDRESS_CHANGED';
export const MMU_CONNECTION_STATE_CHANGED = 'MMU_CONNECTION_STATE_CHANGED';
export const HYMOTSE_STARTED = 'HYMOTSE_STARTED';
export const HYMOTSE_CONNECTED = 'HYMOTSE_CONNECTED';
